import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DockItemFacade } from './dock-item.facade';
import { setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class DockItemGuard {
  constructor(private dockItemFacade: DockItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { dockId },
    } = route;
    this.dockItemFacade.setDockId(+dockId);
    return of(true);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.dockItemFacade);
  }
}
